'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../../atoms/IconSvg/index.js');
var index$1 = require('../../atoms/Button/index.js');
var ReactDOM = require('react-dom');
var image = require('./image.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

var Modals = /*#__PURE__*/function (_React$PureComponent) {
  _rollupPluginBabelHelpers.inherits(Modals, _React$PureComponent);

  var _super = _rollupPluginBabelHelpers.createSuper(Modals);

  function Modals() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Modals);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "modalContent", React__default['default'].createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleKeyDown", function (e) {
      var isEnter = e.keyCode === 13;
      var isEsc = e.keyCode === 27;

      if (isEnter) {
        e.preventDefault();

        _this.handleSelect();
      }

      if (isEsc) {
        _this.hideModal(e);
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleOverlayClose", function (e) {
      var _this$modalContent;

      var currentModalContent = (_this$modalContent = _this.modalContent) === null || _this$modalContent === void 0 ? void 0 : _this$modalContent.current;

      if (currentModalContent && !currentModalContent.contains(e.target)) {
        e.preventDefault();

        _this.hideModal(e);
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "showModal", function () {
      _this.props.showModal();
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "hideModal", function (e) {
      if (e) {
        e.stopPropagation();
      }

      _this.props.hideModal(e);
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleSelect", function (e) {
      _this.props.hideModal(e);

      _this.props.onConfirm();
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleCancel", function (e) {
      _this.props.hideModal(e);

      if (_this.props.onCancel) _this.props.onCancel();
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Modals, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.handleKeyDown, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeAttribute('style');
      document.removeEventListener('keydown', this.handleKeyDown, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          cancelText = _this$props.cancelText,
          confirmText = _this$props.confirmText;
      var container = this.props.container ? document.querySelector(this.props.container) : document.body;
      return ReactDOM__default['default'].createPortal( /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-org-modal-overlay ".concat(this.props.className),
        onClick: this.handleOverlayClose,
        onKeyDown: this.handleKeyDown,
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-org-confirm-modal",
        ref: this.modalContent
      }, /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        onClick: this.hideModal,
        className: "ds-org-modal-close"
      }, /*#__PURE__*/React__default['default'].createElement(index, {
        className: "ds-org-modal-close-icon",
        icon: "cross",
        localSource: this.props.localSource
      })), /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-org-confirm-modal-header"
      }, title), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-org-confirm-modal-text"
      }, subtitle), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-org-confirm-modal-buttons"
      }, /*#__PURE__*/React__default['default'].createElement(index$1, {
        onSelect: this.handleCancel,
        secondary: true
      }, cancelText), /*#__PURE__*/React__default['default'].createElement(index$1, {
        onSelect: this.handleSelect,
        className: "ds-org-confirm-modal-right-button"
      }, confirmText))))) || [], container);
    }
  }]);

  return Modals;
}(React__default['default'].PureComponent);

_rollupPluginBabelHelpers.defineProperty(Modals, "propTypes", {
  onCancel: PropTypes__default['default'].func,
  onConfirm: PropTypes__default['default'].func.isRequired,
  showModal: PropTypes__default['default'].func.isRequired,
  hideModal: PropTypes__default['default'].func.isRequired,
  className: PropTypes__default['default'].string,
  container: PropTypes__default['default'].string,
  localSource: PropTypes__default['default'].bool,
  title: PropTypes__default['default'].string,
  subtitle: PropTypes__default['default'].node,
  cancelText: PropTypes__default['default'].string,
  confirmText: PropTypes__default['default'].string
});

_rollupPluginBabelHelpers.defineProperty(Modals, "defaultProps", {
  onCancel: function onCancel() {},
  className: '',
  container: '',
  localSource: false,
  subtitle: '',
  title: '',
  cancelText: 'Cancel',
  confirmText: 'Confirm'
});
Modals.Image = image;

module.exports = Modals;
